import styled, { css } from "styled-components";
const SectionGrid = styled.div(
  ({ $columns, theme }) => css`
    display: grid;
    grid-template-columns: ${$columns != null ? $columns : "1fr 1fr"};
    column-gap: 40px;

    @media (max-width: ${theme.breakpoints.max.md}) {
      grid-template-columns: 1fr;
    }
  `
);
export default SectionGrid;
